import type { PartnerShopListItem, PartnerShopListResponse } from '@/types/partnerShop';

export const partnerShopListMock: PartnerShopListResponse = {
  total: 40,
  filters: {
    areas: [
      { areaName: '청담', count: 12 },
      { areaName: '강남', count: 8 },
      { areaName: '종로', count: 5 },
      { areaName: '압구정', count: 3 },
      { areaName: '성수', count: 4 },
      { areaName: '잠실', count: 3 },
      { areaName: '경기', count: 3 },
      { areaName: '기타', count: 2 },
    ],
    quickFilters: [
      { key: 'all', label: '전체', count: 40 },
      { key: 'cheongdam', label: '청담에서 보기', count: 12 },
      { key: 'shooting', label: '촬영복까지 필요한 경우', count: 5 },
      { key: 'premium', label: '프리미엄 맞춤', count: 9 },
      { key: 'rental', label: '대여도 보고 싶은 경우', count: 6 },
      { key: 'promotion', label: '계약 혜택 있는 곳', count: 7 },
    ],
  },
  list: [
    {
      id: 1,
      shopName: '헤리츠테일러 청담본점',
      displayName: '헤리츠테일러',
      shopSlug: 'heritztailor-cheongdam',
      shopCategory: '예복',
      areaName: '청담',
      branchName: '청담본점',
      shortDescription: '촬영과 본식을 모두 고려한 맞춤형 예복 상담',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20Korean%20menswear%20tailor%20shop%20interior%20warm%20cream%20tones%20premium%20suit%20display%20wooden%20shelves%20soft%20ambient%20lighting%20editorial%20photography%20sophisticated%20atmosphere%20high-end%20bespoke%20atelier&width=800&height=500&seq=shops-hero-ht-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Premium%20navy%20bespoke%20suit%20on%20mannequin%20in%20luxury%20Korean%20tailor%20atelier%20soft%20warm%20lighting%20cream%20background%20editorial%20product%20photography%20clean%20elegant%20minimal&width=400&height=250&seq=shops-thumb-ht-1&orientation=landscape',
      reviewSummaryText: '핏 조정과 상담 설명에 대한 만족도가 반복적으로 확인돼요.',
      reviewCount: 284,
      directReviewCount: 96,
      reviewPhotoCount: 36,
      lookbookPhotoCount: 14,
      keywords: ['체형보정', '촬영복구성', '프리미엄원단'],
      badges: ['후기요약'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '계약 혜택 제공',
      priceText: '1,290,000원~',
      sortOrder: 1,
    },
    {
      id: 2,
      shopName: '빌리언즈테일러',
      displayName: '빌리언즈테일러',
      shopSlug: 'billions-tailor',
      shopCategory: '예복',
      areaName: '청담',
      branchName: null,
      shortDescription: '원단 선택부터 구성까지 자세한 설명이 돋보이는 업체',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20Korean%20menswear%20atelier%20with%20premium%20wool%20fabric%20rolls%20displayed%20on%20wooden%20shelves%20warm%20ambient%20lighting%20cream%20walls%20sophisticated%20editorial%20photography%20elegant%20interior%20design&width=800&height=500&seq=shops-hero-bt-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Charcoal%20grey%20premium%20tailored%20suit%20jacket%20detail%20close-up%20on%20wooden%20hanger%20warm%20lighting%20Korean%20bespoke%20tailor%20atelier%20editorial%20product%20photography&width=400&height=250&seq=shops-thumb-bt-1&orientation=landscape',
      reviewSummaryText: '원단 선택과 예복 구성 설명이 자세하다는 후기가 많아요.',
      reviewCount: 198,
      directReviewCount: 72,
      reviewPhotoCount: 28,
      lookbookPhotoCount: 10,
      keywords: ['맞춤예복', '원단선택', '상담친절'],
      badges: ['후기요약', '사진많음'],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '1,100,000원~',
      sortOrder: 2,
    },
    {
      id: 3,
      shopName: '아틀레',
      displayName: '아틀레',
      shopSlug: 'at-le',
      shopCategory: '예복',
      areaName: '강남',
      branchName: null,
      shortDescription: '촬영복과 본식 예복을 함께 비교하기 좋은 구성',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Contemporary%20Korean%20menswear%20atelier%20with%20clean%20minimal%20interior%20white%20walls%20warm%20beige%20accents%20premium%20suit%20display%20natural%20daylight%20editorial%20photography%20elegant%20calm%20atmosphere&width=800&height=500&seq=shops-hero-at-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Light%20grey%20premium%20wedding%20suit%20on%20display%20in%20modern%20Korean%20atelier%20soft%20natural%20lighting%20cream%20background%20editorial%20product%20photography%20clean%20elegant%20composition&width=400&height=250&seq=shops-thumb-at-1&orientation=landscape',
      reviewSummaryText: '촬영복 구성과 본식 예복을 함께 비교하기 좋다는 평가가 있어요.',
      reviewCount: 156,
      directReviewCount: 54,
      reviewPhotoCount: 22,
      lookbookPhotoCount: 8,
      keywords: ['촬영복', '본식예복', '대여가능'],
      badges: ['룩북보유'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '셔츠 2장 증정',
      priceText: '990,000원~',
      sortOrder: 3,
    },
    {
      id: 4,
      shopName: '포튼가먼트',
      displayName: '포튼가먼트',
      shopSlug: 'forten-garment',
      shopCategory: '예복',
      areaName: '종로',
      branchName: null,
      shortDescription: '가성비 좋은 기본 구성과 꼼꼼한 맞춤',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20Korean%20tailor%20shop%20interior%20with%20fabric%20swatches%20on%20display%20table%20wooden%20furniture%20cream%20walls%20soft%20pendant%20lighting%20editorial%20photography%20cozy%20professional%20atmosphere&width=800&height=500&seq=shops-hero-fg-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Navy%20blue%20classic%20suit%20jacket%20on%20wooden%20mannequin%20warm%20ambient%20lighting%20Korean%20tailor%20atelier%20editorial%20product%20photography%20elegant%20minimal%20composition&width=400&height=250&seq=shops-thumb-fg-1&orientation=landscape',
      reviewSummaryText: '가성비와 기본 구성에 대한 만족도가 반복적으로 언급돼요.',
      reviewCount: 132,
      directReviewCount: 48,
      reviewPhotoCount: 18,
      lookbookPhotoCount: 6,
      keywords: ['가성비', '기본구성', '대여가능'],
      badges: ['인기급상승'],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '790,000원~',
      sortOrder: 4,
    },
    {
      id: 5,
      shopName: '루쏘소',
      displayName: '루쏘소',
      shopSlug: 'lusso',
      shopCategory: '예복',
      areaName: '강남',
      branchName: null,
      shortDescription: '지점 접근성과 편안한 상담 프로세스',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Spacious%20modern%20Korean%20menswear%20showroom%20with%20floor-to-ceiling%20windows%20natural%20daylight%20premium%20suits%20on%20display%20minimalist%20interior%20warm%20beige%20tones%20editorial%20photography%20luxurious%20yet%20approachable&width=800&height=500&seq=shops-hero-ls-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Dark%20charcoal%20bespoke%20suit%20with%20subtle%20pinstripe%20on%20display%20in%20luxury%20Korean%20atelier%20soft%20warm%20lighting%20cream%20background%20editorial%20product%20photography&width=400&height=250&seq=shops-thumb-ls-1&orientation=landscape',
      reviewSummaryText: '지점 접근성과 상담 프로세스가 편하다는 평가가 많아요.',
      reviewCount: 178,
      directReviewCount: 63,
      reviewPhotoCount: 25,
      lookbookPhotoCount: 9,
      keywords: ['접근성', '상담', '대여가능'],
      badges: ['후기요약'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '타이 1종 증정',
      priceText: '950,000원~',
      sortOrder: 5,
    },
    {
      id: 6,
      shopName: 'HK테일러',
      displayName: 'HK테일러',
      shopSlug: 'hk-tailor',
      shopCategory: '예복',
      areaName: '청담',
      branchName: null,
      shortDescription: '클래식한 수트핏과 체형 보정에 강점',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Classic%20heritage%20Korean%20tailor%20shop%20with%20rich%20wooden%20paneling%20vintage%20sewing%20machines%20on%20display%20premium%20wool%20fabrics%20warm%20golden%20lighting%20editorial%20photography%20timeless%20elegant%20atmosphere&width=800&height=500&seq=shops-hero-hk-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Classic%20black%20tuxedo%20on%20wooden%20mannequin%20rich%20warm%20lighting%20heritage%20Korean%20tailor%20shop%20editorial%20product%20photography%20timeless%20elegance&width=400&height=250&seq=shops-thumb-hk-1&orientation=landscape',
      reviewSummaryText: '클래식한 수트핏과 체형 보정에 대한 후기가 확인돼요.',
      reviewCount: 211,
      directReviewCount: 78,
      reviewPhotoCount: 30,
      lookbookPhotoCount: 12,
      keywords: ['클래식', '수트핏', '혼주예복'],
      badges: ['후기요약', '사진많음'],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '1,350,000원~',
      sortOrder: 6,
    },
    {
      id: 7,
      shopName: '보헨',
      displayName: '보헨',
      shopSlug: 'bohen',
      shopCategory: '예복',
      areaName: '성수',
      branchName: null,
      shortDescription: '감도 있는 룩북과 세련된 스타일',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20industrial-chic%20Korean%20menswear%20atelier%20in%20Seongsu%20exposed%20brick%20walls%20premium%20suits%20modern%20art%20pieces%20warm%20ambient%20lighting%20editorial%20photography%20creative%20sophisticated%20atmosphere&width=800&height=500&seq=shops-hero-bh-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Stylish%20slim-fit%20burgundy%20suit%20jacket%20on%20display%20in%20trendy%20Korean%20atelier%20warm%20moody%20lighting%20editorial%20fashion%20photography%20creative%20composition&width=400&height=250&seq=shops-thumb-bh-1&orientation=landscape',
      reviewSummaryText: '감도 있는 룩북과 세련된 스타일을 선호하는 고객에게 어울려요.',
      reviewCount: 145,
      directReviewCount: 51,
      reviewPhotoCount: 24,
      lookbookPhotoCount: 16,
      keywords: ['감성룩북', '프리미엄맞춤', '스타일'],
      badges: ['룩북보유', '인기급상승'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '룩북 촬영 1컷 무료',
      priceText: '1,200,000원~',
      sortOrder: 7,
    },
    {
      id: 8,
      shopName: '로드앤테일러',
      displayName: '로드앤테일러',
      shopSlug: 'lord-and-tailor',
      shopCategory: '예복',
      areaName: '잠실',
      branchName: null,
      shortDescription: '방문 상담과 구성 안내가 안정적인 업체',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20Korean%20tailor%20shop%20near%20Jamsil%20with%20comfortable%20consultation%20area%20premium%20fabric%20samples%20on%20table%20soft%20lighting%20cream%20walls%20editorial%20photography%20friendly%20professional%20atmosphere&width=800&height=500&seq=shops-hero-lt-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Soft%20beige%20linen%20blend%20suit%20jacket%20on%20display%20warm%20natural%20lighting%20Korean%20tailor%20atelier%20editorial%20product%20photography%20relaxed%20elegant%20composition&width=400&height=250&seq=shops-thumb-lt-1&orientation=landscape',
      reviewSummaryText: '방문 상담과 구성 안내가 안정적이라는 평가가 있어요.',
      reviewCount: 167,
      directReviewCount: 59,
      reviewPhotoCount: 20,
      lookbookPhotoCount: 7,
      keywords: ['방문상담', '구성안내', '혼주예복'],
      badges: [],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '890,000원~',
      sortOrder: 8,
    },
    {
      id: 9,
      shopName: '르꼬르동테일러',
      displayName: '르꼬르동테일러',
      shopSlug: 'le-cordon-tailor',
      shopCategory: '예복',
      areaName: '청담',
      branchName: null,
      shortDescription: '프렌치 감성의 수제 맞춤 예복',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Parisian-inspired%20luxury%20Korean%20tailor%20atelier%20with%20ornate%20mirror%20gold%20accents%20cream%20walls%20premium%20suits%20on%20display%20soft%20chandelier%20lighting%20editorial%20photography%20refined%20elegant%20atmosphere&width=800&height=500&seq=shops-hero-lc-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Ivory%20cream%20tailored%20wedding%20suit%20on%20wooden%20mannequin%20soft%20golden%20lighting%20luxury%20Korean%20atelier%20editorial%20product%20photography%20refined%20elegance&width=400&height=250&seq=shops-thumb-lc-1&orientation=landscape',
      reviewSummaryText: '핸드메이드 완성도와 소재 퀄리티에 대한 만족도가 높아요.',
      reviewCount: 143,
      directReviewCount: 48,
      reviewPhotoCount: 19,
      lookbookPhotoCount: 11,
      keywords: ['핸드메이드', '프렌치감성', '프리미엄원단'],
      badges: ['후기요약'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '벨트 1종 증정',
      priceText: '1,550,000원~',
      sortOrder: 9,
    },
    {
      id: 10,
      shopName: '디에고밀라노',
      displayName: '디에고밀라노',
      shopSlug: 'diego-milano',
      shopCategory: '예복',
      areaName: '강남',
      branchName: null,
      shortDescription: '이탈리안 수입 원단 기반의 프리미엄 예복',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Italian-inspired%20luxury%20Korean%20menswear%20atelier%20marble%20accents%20premium%20wool%20fabrics%20gold%20trim%20details%20warm%20ambient%20lighting%20editorial%20photography%20sophisticated%20Mediterranean%20elegance&width=800&height=500&seq=shops-hero-dm-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Premium%20Italian%20wool%20midnight%20blue%20suit%20on%20display%20in%20luxury%20Korean%20atelier%20golden%20warm%20lighting%20editorial%20product%20photography%20exclusive%20elegance&width=400&height=250&seq=shops-thumb-dm-1&orientation=landscape',
      reviewSummaryText: '수입 원단의 질감과 색감이 다르다는 후기가 확인돼요.',
      reviewCount: 122,
      directReviewCount: 41,
      reviewPhotoCount: 16,
      lookbookPhotoCount: 8,
      keywords: ['수입원단', '이탈리안', '프리미엄'],
      badges: [],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '1,800,000원~',
      sortOrder: 10,
    },
    {
      id: 11,
      shopName: '더바르고 청담',
      displayName: '더바르고',
      shopSlug: 'the-bargo-cheongdam',
      shopCategory: '예복',
      areaName: '청담',
      branchName: '청담',
      shortDescription: '셔츠와 슈트를 함께 맞추는 토탈 코디',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20Korean%20menswear%20shop%20with%20integrated%20shirt%20and%20suit%20displays%20clean%20lines%20cream%20walls%20warm%20track%20lighting%20editorial%20photography%20premium%20total%20styling%20concept&width=800&height=500&seq=shops-hero-tb-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20navy%20suit%20with%20white%20dress%20shirt%20and%20silk%20tie%20on%20display%20in%20modern%20Korean%20atelier%20warm%20lighting%20editorial%20product%20photography&width=400&height=250&seq=shops-thumb-tb-1&orientation=landscape',
      reviewSummaryText: '셔츠 맞춤까지 한 번에 가능해서 편리하다는 후기가 많아요.',
      reviewCount: 189,
      directReviewCount: 67,
      reviewPhotoCount: 27,
      lookbookPhotoCount: 9,
      keywords: ['셔츠맞춤', '토탈코디', '대여가능'],
      badges: ['후기요약', '사진많음'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '셔츠 3장 구매 시 1장 무료',
      priceText: '1,100,000원~',
      sortOrder: 11,
    },
    {
      id: 12,
      shopName: '시옷',
      displayName: '시옷',
      shopSlug: 'siot',
      shopCategory: '예복',
      areaName: '성수',
      branchName: null,
      shortDescription: '트렌디한 감각의 젊은 예복 스타일',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Hip%20creative%20Korean%20tailor%20shop%20in%20Seongsu%20district%20artistic%20wall%20murals%20contemporary%20suit%20designs%20warm%20industrial%20lighting%20editorial%20photography%20youthful%20trendy%20atmosphere&width=800&height=500&seq=shops-hero-si-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Modern%20slim-fit%20olive%20green%20suit%20on%20display%20in%20trendy%20Korean%20atelier%20warm%20moody%20lighting%20editorial%20fashion%20photography%20artistic%20composition&width=400&height=250&seq=shops-thumb-si-1&orientation=landscape',
      reviewSummaryText: '젊은 감각의 디자인과 트렌디한 핏을 원한다면 추천해요.',
      reviewCount: 108,
      directReviewCount: 38,
      reviewPhotoCount: 15,
      lookbookPhotoCount: 13,
      keywords: ['트렌디', '대여가능', '디자인'],
      badges: ['룩북보유'],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '850,000원~',
      sortOrder: 12,
    },
    {
      id: 13,
      shopName: '준오테일러 압구정',
      displayName: '준오테일러',
      shopSlug: 'juno-tailor-apgujeong',
      shopCategory: '예복',
      areaName: '압구정',
      branchName: '압구정',
      shortDescription: '20년 경력의 베테랑 테일러가 직접 상담',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Established%20Korean%20master%20tailor%20shop%20in%20Apgujeong%20vintage%20wooden%20counters%20measuring%20tape%20and%20scissors%20premium%20fabrics%20warm%20classic%20lighting%20editorial%20photography%20heritage%20craftsmanship%20atmosphere&width=800&height=500&seq=shops-hero-jt-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Expertly%20tailored%20charcoal%20three-piece%20suit%20on%20wooden%20mannequin%20warm%20heritage%20lighting%20Korean%20master%20tailor%20atelier%20editorial%20product%20photography&width=400&height=250&seq=shops-thumb-jt-1&orientation=landscape',
      reviewSummaryText: '오랜 경력의 테일러가 직접 상담해 신뢰도가 높다는 후기가 있어요.',
      reviewCount: 234,
      directReviewCount: 85,
      reviewPhotoCount: 32,
      lookbookPhotoCount: 10,
      keywords: ['베테랑', '경력20년', '신뢰감'],
      badges: ['후기요약', '사진많음'],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '시즌 한정 추가 할인',
      priceText: '1,400,000원~',
      sortOrder: 13,
    },
    {
      id: 14,
      shopName: '까사델라모다',
      displayName: '까사델라모다',
      shopSlug: 'casa-della-moda',
      shopCategory: '예복',
      areaName: '종로',
      branchName: null,
      shortDescription: '전통과 현대를 아우르는 예복 스타일',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20tailor%20shop%20in%20Jongno%20district%20traditional%20hanok-inspired%20interior%20elements%20modern%20suit%20displays%20warm%20natural%20lighting%20editorial%20photography%20classic%20meets%20contemporary%20atmosphere&width=800&height=500&seq=shops-hero-cd-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Classic%20double-breasted%20navy%20suit%20on%20display%20in%20elegant%20Korean%20atelier%20with%20traditional%20accents%20warm%20lighting%20editorial%20product%20photography%20timeless%20style&width=400&height=250&seq=shops-thumb-cd-1&orientation=landscape',
      reviewSummaryText: '전통적인 핏과 현대적 감각을 조화롭게 표현한다는 후기가 있어요.',
      reviewCount: 98,
      directReviewCount: 34,
      reviewPhotoCount: 14,
      lookbookPhotoCount: 5,
      keywords: ['전통', '현대적', '혼주예복'],
      badges: [],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '750,000원~',
      sortOrder: 14,
    },
    {
      id: 15,
      shopName: '노블레스옴므',
      displayName: '노블레스옴므',
      shopSlug: 'noblesse-homme',
      shopCategory: '예복',
      areaName: '경기',
      branchName: '분당',
      shortDescription: '분당 지역의 프리미엄 예복 전문 업체',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Spacious%20premium%20Korean%20tailor%20shop%20in%20Bundang%20modern%20interior%20with%20comfortable%20fitting%20area%20large%20mirrors%20warm%20lighting%20cream%20walls%20editorial%20photography%20suburban%20luxury%20atmosphere&width=800&height=500&seq=shops-hero-nh-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Rich%20brown%20textured%20suit%20jacket%20on%20display%20in%20premium%20Korean%20atelier%20warm%20golden%20lighting%20editorial%20product%20photography%20sophisticated%20suburban%20elegance&width=400&height=250&seq=shops-thumb-nh-1&orientation=landscape',
      reviewSummaryText: '분당 지역에서 접근성 좋고 상담이 꼼꼼하다는 후기가 확인돼요.',
      reviewCount: 87,
      directReviewCount: 31,
      reviewPhotoCount: 12,
      lookbookPhotoCount: 6,
      keywords: ['경기권', '프리미엄', '꼼꼼상담'],
      badges: [],
      isCertified: 1,
      hasPromotion: true,
      promotionText: '분당 지역 한정 할인',
      priceText: '1,050,000원~',
      sortOrder: 15,
    },
    {
      id: 16,
      shopName: '테일러드바이케이',
      displayName: '테일러드바이케이',
      shopSlug: 'tailored-by-k',
      shopCategory: '예복',
      areaName: '잠실',
      branchName: null,
      shortDescription: '체형 분석 기반의 사이언스 맞춤 예복',
      heroImageUrl: 'https://readdy.ai/api/search-image?query=Modern%20tech-integrated%20Korean%20tailor%20shop%20with%20body%20scanning%20area%20clean%20white%20interior%20soft%20blue-grey%20accents%20warm%20lighting%20editorial%20photography%20innovative%20premium%20atmosphere&width=800&height=500&seq=shops-hero-tk-1&orientation=landscape',
      heroThumbnailUrl: 'https://readdy.ai/api/search-image?query=Precision-tailored%20grey%20suit%20on%20display%20in%20modern%20Korean%20atelier%20with%20digital%20measurement%20tools%20warm%20clean%20lighting%20editorial%20product%20photography&width=400&height=250&seq=shops-thumb-tk-1&orientation=landscape',
      reviewSummaryText: '체형 분석을 통해 정확한 핏을 맞춰준다는 점이 인상적이에요.',
      reviewCount: 115,
      directReviewCount: 42,
      reviewPhotoCount: 17,
      lookbookPhotoCount: 7,
      keywords: ['체형분석', '정확한핏', '대여가능'],
      badges: ['인기급상승'],
      isCertified: 1,
      hasPromotion: false,
      promotionText: null,
      priceText: '980,000원~',
      sortOrder: 16,
    },
  ],
};

export const allAreas = ['전체', '청담', '강남', '종로', '압구정', '성수', '잠실', '경기', '기타'] as const;